import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    try {
      const Sentry = require('@sentry/react');
      Sentry.captureException(error, { extra: { componentStack: errorInfo?.componentStack } });
    } catch (_) {
      // Sentry not available
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="app-container">
          <div className="app-wrapper">
            <div className="app-card">
              <div className="app-header">
                <h1>Something went wrong</h1>
              </div>
              <p style={{ marginBottom: '1rem', color: '#666' }}>
                An unexpected error occurred. Please try again or refresh the page.
              </p>
              {process.env.NODE_ENV === 'development' && this.state.error && (
                <pre style={{
                  background: '#f5f5f5',
                  padding: '1rem',
                  borderRadius: '4px',
                  fontSize: '0.85rem',
                  overflowX: 'auto',
                  marginBottom: '1rem',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}>
                  {this.state.error.toString()}
                </pre>
              )}
              <button className="btn btn-yellow" onClick={this.handleReset}>
                Try Again
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
